<template>
  <div class="d-flex p-2 flex-row question-content">
    <div class="question-label">
      <span v-if="model.is_correct" class="text-success"><i class="fas fa-check-circle"></i></span>
      <span v-if="!model.is_correct" class="text-danger"><i class="fas fa-minus-circle"></i></span>
      {{ label }}.
    </div>
    <div class="flex-fill question-body">
      <div>
        <div v-html="question.text"></div>

        <div class="flex-fill p-2">
          <media-preview v-if="question.media_id" :id="question.media_id" v-model="question.media" style="margin:0 auto"/>
        </div>

        <div>
          <label>Choices</label>
          <div v-if="!question.answer" class="alert alert-danger">
            This question was not answered.
          </div>
          <div v-if="question.type == 'checkbox'">
            <b-form-checkbox-group id="checkbox-group-1" v-model="model.choice_ids" name="answers-1" stacked>
              <b-form-checkbox v-for="c in choices" :key="c.id" :value="c.id" :disabled="true">
                <choice-label :choice="c" :answer="question.answer"/>
                <media-preview v-if="c.media_id" :id="c.media_id" v-model="c.media" style="margin-left:1.5rem"/>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>

          <ul v-if="question.type == 'radio'">
            <li v-for="c in choices" :key="c.id">
              <div class="p-1">
                <input v-model="selectedOption" :value="c.id" :name="componentId" type="radio" disabled/>
                <choice-label :choice="c" :answer="question.answer"/>
                <media-preview v-if="c.media_id" :id="c.media_id" v-model="c.media" style="margin-left:1.5rem"/>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import mediaPreview from '@/components/common/media/object-media-preview'
import choiceLabel from './question-label'

export default {
  components:{
    choiceLabel,
    mediaPreview
  },
  props:{
    value: {type:null, default: ''},
    question: {type:Object, required: true},
    label: {type:null, required: true}
  },
  data(){
    return {
    }
  },
  computed:{
    componentId(){
      return this._uid
    },
    choices(){
      return _.sortBy(this.question.choices, ['order'])
    },
    model:{
      get(){ return this.value || {}},
      set(model) { this.$emit('input', model)}
    },
    selectedOption:{
      get(){
        if(this.model && this.model.choice_ids){
          return this.model.choice_ids[0]
        }else{
          return null
        }
      },
      set(option){
        if(!this.model){
          return
        }
        if(option){
          this.model.choice_ids = [option]
        }else{
          this.model.choice_ids = []
        }
      }
    }
  },
  watch:{
    model(val){
      this.$emit('input', val)
    },
    value(val){
      this.model = val || {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .question-content{
    padding: 0 .5rem;
  }

  .question-label{
    min-width:1.35rem;
    white-space: nowrap !important;
  }

  .question-body{
    margin-left:1rem;
    width:100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/reports/response-detail/question.vue